import currentUser from '@rover/globals/currentUser';
import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import inject from './injector';
import { localStorage, sessionStorage } from './storage';
import { appendUrlParams } from './url';

const location = inject('location');

const logout = ref => {
  localStorage.clear();
  sessionStorage.clear();
  currentUser.authenticated = false;
  location.href = ref ? appendUrlParams(Rover.urls.logout, { ref }) : Rover.urls.logout;
};

function init() {
  currentUser
    .waitForAnonymousUserLoaded()
    .then(user => showAnonymousElements())
    .catch(() => {});
}

function showAnonymousElements() {
  $('.js-anonymous-user').removeClass('hide');
}

Rover.utils = Rover.utils || {};
Rover.utils.logout = logout;

export default {
  init,
  showAnonymousElements,
  logout,
};



// WEBPACK FOOTER //
// ../utilities/auth.js